module.exports = __webpack_public_path__ + "static/media/01_A7_01.afee0eac.png";